<template lang="pug">
  div
    v-btn(@click="$refs.input.click()") 選擇圖片
    .caption 圖片大小限制1MB，格式為jpg、png、jpeg
    v-dialog(v-model="alert")
      v-card
        v-card-text.error--text.text-xs-center.title 最多上傳{{ limit }}張照片
        v-card-actions
          v-spacer
          v-btn(@click="alert = false") 確認
          v-spacer
    input.d-none(ref="input"
      type="file"
      accept="image/jpg,image/png,image/jpeg"
      multiple
      @change="upload")
    v-layout(v-if="value ? value.length > 0 : false")
      v-flex
        v-card
          v-container(grid-list-sm
            fluid)
            dnd.layout.row.wrap(:value="value"
              @input="update")
              v-flex(v-for="(url, index) in value"
                :key="url"
                :class="$style.item"
                xs4
                sm3
                md2)
                v-card(flat
                  tile)
                  base-url-provider(:filepath="url")
                    template(v-slot="{ url }")
                      v-img(:src="url" contain)
                  div(:class="$style.tool")
                    v-btn(:class="$style.close"
                      fab
                      dark
                      color="error"
                      @click="removeItem(index)")
                      v-icon(dark) close
                    div(:class="$style.index")
                      span {{ index + 1 }}
                    div(:class="$style.bg")
</template>

<script>
import Dnd from "vuedraggable";
import BaseUrlProvider from "@/components/core/BaseUrlProvider.vue";

export default {
  name: "ImagesEditor",
  components: {
    Dnd,
    BaseUrlProvider
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    limit: {
      type: [Number, String],
      default: 5
    }
  },
  data() {
    return {
      alert: false
    };
  },
  methods: {
    upload(e) {
      const input = e.target;

      if (input.files) {
        const items = this.value || [];
        if (input.files.length + items.length < this.limit + 1) {
          for (let file of input.files) {
            if (file.size > 1024 * 1000) continue;
            const reader = new FileReader();

            reader.onload = e => {
              const dataURL = e.target.result;
              items.push(dataURL);
            };

            reader.readAsDataURL(file);
          }

          this.update(items);
        } else {
          this.alert = true;
        }
      }
    },
    removeItem(index) {
      const items = [...this.value];
      items.splice(index, 1);
      this.update(items);
    },
    update(val) {
      this.$emit("update", val);
    }
  }
};
</script>

<style module lang="styl">
.item
  position relative
  &:hover
    .tool
      display flex

.tool
  display none
  position absolute
  justify-content space-between
  flex-direction column
  width 100%
  height 100%
  top 0
  left 0
  text-align center
  .index
    position absolute
    top 50%
    left 50%
    transform translate(-50%, -50%)
    font-size 24px
    font-weight bold
    color white
    z-index 1
.bg
  display block
  position absolute
  width 100%
  height 100%
  top 0
  left 0
  background-color black
  opacity .4

.close
  position relative
  top 0%
  left 70%
  width 25px
  height 25px
  z-index 1

.edit
  z-index 1
</style>
